<template>
  <div id="DataDive">
    <div v-if="workersData && mcdNameData">
      <div style="font-weight: bold; font-size: medium">Tract: {{ geoid }} in {{ mcdNameData.city_name }}</div>
      <table>
        <tr>
          <th class="columnname" style="position: sticky; top: 0;">{{ mappedCategory }}</th>
          <th class="columnname" style="text-align: end; position: sticky; top: 0;">Residence</th>
          <th class="columnname" style="text-align: end; position: sticky; top: 0;">Workplace</th>
        </tr>
        <tr
            v-for="nit in workersNitsSorted"
            v-bind:key="nit"
        >
          <th>{{ lookupById[nit] || nit }}</th>
          <td>{{ format(workersData[nit].Residence || 0) }}</td>
          <td>{{ format(workersData[nit].Workplace || 0) }}</td>
        </tr>
        <tr>
          <th class="columnname">Total</th>
          <td>{{ format(workersDataTotal().Residence) }}</td>
          <td>{{ format(workersDataTotal().Workplace) }}</td>

        </tr>
      </table>
    </div>
    <hr v-if="potentialData">
    <div v-if="potentialData" style="">

      <table>
        <tr>
          <th class="columnname">Age Group</th>
          <th class="columnname" style="text-align: end;">Non Working Residents</th>
        </tr>
        <tr>
          <th>16-24</th>
          <td> {{ format(potentialData.potential_workers_16_24) }}</td>
        </tr>
        <tr>
          <th>25-64</th>
          <td> {{ format(potentialData.potential_workers_25_64) }}</td>
        </tr>
        <tr>
          <th>65 and Over</th>
          <td>{{ format(potentialData.potential_workers_65_and_over) }}</td>
        </tr>
        <tr>
          <th class="columnname">Total</th>
          <td> {{ format(potentialData.total_potential_workers) }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import {queryFeatures} from '@esri/arcgis-rest-feature-service'
import * as d3 from "d3";

export default {
  name: "DataDive",
  props: ["geoid", "mappedCategory", "naics"],
  data: function () {
    return {
      workersData: null,
      potentialData: null,
      mcdNameData: null,
    }
  },
  computed: {
    workersRequestOptions: function () {
      let category = this.mappedCategory
      if (this.mappedCategory === 'Flow') {
        category = 'Industry'
      }
      let codes = `naics_soc IN (${this.naics.join(',')})`;
      if (this.naics.length === 0) {
        codes = `1=1`;
      }
      let column = 'workers16plus'
      let url = "https://services1.arcgis.com/xUx8EjNc6egUPYWh/arcgis/rest/services/workers_by_industryandoccupation_by_tract/FeatureServer/0"
      let where = `geoid10 = ${this.geoid} and indicator = '${category}' and ${codes} and naics_soc <> 99 and naics_soc <> 990000`;

      return {
        url: url,
        where: where,
        groupByFieldsForStatistics: 'dset, naics_soc',
        outStatistics: [
          {
            onStatisticField: column,
            statisticType: 'sum',
            outStatisticFieldName: 'workers16plus',
          }],
        f: "json",
        outFields: ['geoid10', 'workers16plus', 'dset', 'naics_soc']
      }
    },
    potentialRequestOptions: function () {
      return {
        url: 'https://services1.arcgis.com/xUx8EjNc6egUPYWh/arcgis/rest/services/worker_potential_2015_2019/FeatureServer/0',
        where: `geoid10 = ${this.geoid}`,
        f: "json",
        outFields: ['geoid10', 'total_potential_workers', 'potential_workers_16_24', 'potential_workers_25_64', 'potential_workers_65_and_over']
      }
    },
    mcdNameRequestOptions: function () {
      return {
        url: 'https://services1.arcgis.com/xUx8EjNc6egUPYWh/arcgis/rest/services/tract10_singlemcd_equiv/FeatureServer/0',
        where: `geoid = ${this.geoid}`,
        f: "json",
        outFields: ['semmcd', 'city_name']
      }
    },
    lookupById: function () {
      return {
        11: 'Agriculture, forestry, fishing and hunting, and mining',
        71: 'Arts, entertainment, recreation, accommodation and food services',
        23: 'Construction',
        65: 'Educational, health and social services',
        55: 'Finance, insurance, real estate and rental and leasing',
        50: 'Information',
        30: 'Manufacturing',
        80: 'Other services (except public administration)',
        60: 'Professional, scientific, management, administrative, and waste management services',
        92: 'Public administration',
        42: 'Retail trade',
        43: 'Transportation and warehousing, and utilities',
        41: 'Wholesale trade',
        1: 'Armed Forces',
        170000: 'Architecture and engineering',
        270000: 'Arts, design, entertainment, sports, and media',
        370000: 'Building and grounds cleaning and maintenance',
        130000: 'Business and financial operations specialists',
        210000: 'Community and social service',
        150000: 'Computer and mathematical',
        470000: 'Construction and extraction',
        250000: 'Education, training, and library',
        119013: 'Farmers and farm managers',
        450000: 'Farming, fishing, and forestry',
        350000: 'Food preparation and serving related',
        290000: 'Healthcare practitioners and technicians',
        310000: 'Healthcare support',
        490000: 'Installation, maintenance, and repair',
        230000: 'Legal',
        190000: 'Life, physical, and social science',
        110000: 'Management',
        550000: 'Military Specific',
        430000: 'Office and administrative support',
        390000: 'Personal care and service',
        510000: 'Production',
        330000: 'Protective service',
        410000: 'Sales and related',
        530000: 'Transportation and material moving',
      }
    },
    workersNitsSorted: function () {
      return Object.keys(this.workersData).sort((a, b) => this.lookupById[a].localeCompare(this.lookupById[b]))
    },
  },
  methods: {
    format: d3.format(',d'),
    workersDataTotal: function () {
      let sum = {'Workplace': 0, 'Residence': 0}
      Object.keys(this.workersData).forEach(
          (n) => {
            sum['Workplace'] += this.workersData[n].Workplace || 0
            sum['Residence'] += this.workersData[n].Residence || 0
          }
      )
      return sum
    },
  },
  watch: {
    workersRequestOptions: {
      immediate: true,
      handler: function () {
        queryFeatures(this.workersRequestOptions).then((res) => {
          this.workersData = null
          if (this.geoid) {
            let out = {}
            res.features.forEach(r => {
              let d = r.attributes
              out[d.naics_soc] = out[d.naics_soc] || {};
              out[d.naics_soc][d.dset] = d.workers16plus;
            })
            this.workersData = out
          }
        })
      }
    },
    potentialRequestOptions: {
      immediate: true,
      handler: function () {
        queryFeatures(this.potentialRequestOptions).then((res) => {
          this.potentialData = null
          if (this.geoid) {
            this.potentialData = res.features[0].attributes ||
                {
                  "total_potential_workers": 0,
                  "potential_workers_16_24": 0,
                  "potential_workers_25_64": 0,
                  "potential_workers_65_and_over": 0
                }
          }
        })
      }
    },
    mcdNameRequestOptions: {
      immediate: true,
      handler: function () {
        queryFeatures(this.mcdNameRequestOptions).then((res) => {
          this.mcdNameData = null
          if (this.geoid) {
            this.mcdNameData = res.features[0].attributes ||
                {
                  "semmcd": 0,
                  "city_name": '',
                }
          }
        })
      }
    },
  }
}
</script>

<style scoped>
table {
  border-collapse: collapse;
  width: 100%;
}

th {
  background: #ffffff;
  border-bottom: 1px black solid;
  font-size: small;
  padding-left: 4px;
  max-width: 350px;
  font-weight: unset;
}

td {
  background: #ffffff;
  border-bottom: 1px black solid;
  font-size: small;
  text-align: end;
}

div#DataDive {
  overflow: auto;
  max-height: 36vh;
}

.columnname {
  font-weight: bolder;
  font-size: medium;
}
</style>
